export enum AppRoutes {
  AuxWindow = "aux-window",
  CallsAlerts = "calls-alerts",
  CreateCall = "create-call",
  EventDetails = "eventdetails",
  Export = "export",
  Login = "login",
  MarginAccountDetails = "margin-account-details",
  Root = "marginprocessing",
}
